// BARCINO — Listing News (/actualites)
const barcinoNews = {
    _filter: null,
    _click_handler: null,

    init() {
        this.destroy();
        this._filter = document.querySelector('.bc-news-filter');
        if (!this._filter) return;

        // Stoppe la propagation avant qu'elle n'atteigne le listener global de
        // Barba sur document — sur les pages Barba, Barba appelle
        // preventDefault() sur tout clic qui ne résout pas vers un <a href>,
        // ce qui empêche le <summary> d'ouvrir nativement son <details> parent.
        this._click_handler = (event) => {
            event.stopPropagation();
        };
        this._filter.addEventListener('click', this._click_handler);
    },

    destroy() {
        if (this._filter && this._click_handler) {
            this._filter.removeEventListener('click', this._click_handler);
        }
        this._filter = null;
        this._click_handler = null;
    },
};

export default barcinoNews;
